import useTheme from '@mui/material/styles/useTheme';
import styled from '@mui/material/styles/styled';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

const StyledButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'color',
})(({ theme, color, selected }) => ({
  padding: '8px 17px',
  borderRadius: 41,
  textAlign: 'center',
  fontSize: '1rem',
  ...(selected
    ? {
        backgroundColor: `${color} !important`,
        '& .MuiTypography-button': {
          color: `${theme.palette.background.paper} !important`,
        },
      }
    : {
        backgroundColor: theme.palette.background.paper,
        '& .MuiTypography-button': {
          color: `${theme.palette.text.primary} !important`,
        },
      }),
  boxShadow: '0px 3px 6px #00000029',
  '&:hover': {
    boxShadow: `0px 3px 6px ${color}29`,
  },
}));

function StyledToggleButton(props) {
  const { checked = false, color = 'primary', label, onToggle, disabled = false } = props;
  const [selected, setSelected] = useState(checked);
  const theme = useTheme();

  useEffect(() => {
    setSelected(checked);
  }, [checked]);

  const handleClick = () => {
    if (!disabled) {
      const status = !selected;
      setSelected(status);
      setTimeout(() => {
        onToggle(status);
      }, 0);
    }
  };

  return (
    <StyledButton
      selected={selected}
      color={
        color === 'primary'
          ? theme.palette.primary.main
          : theme.palette.secondary.main
      }
      type="button"
      onClick={handleClick}>
      <Typography variant="button">{label}</Typography>
    </StyledButton>
  );
}

StyledToggleButton.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['primary', 'secondary']),
  checked: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default StyledToggleButton;
